import {
  Component,
  Injector,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import {
  FilterType,
  ModelField,
} from '@app/shared/interfaces/front-end-column';
import { ListPayload } from '@product/shared/models/ListPayload';
import { ProductService } from '@product/shared/services/product.service';
import { tap } from 'rxjs';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { Product } from '@product/shared/models/product';
import { productColumns } from '@product/shared/product-base-logic';
import { FilterOperator } from '@product/shared/models/Enums.enum';

@Component({
  selector: 'app-product-field-relation',
  templateUrl: './product-field-relation.component.html',
  styleUrls: ['./product-field-relation.component.less'],
})
export class ProductFieldRelationComponent
  extends BaseComponent
  implements OnInit
{
  @ViewChild('productsDrawerTemplate', { static: false })
  productsDrawerTemplate: TemplateRef<any>;
  @ViewChild('recordsDrawerFooter') recordsDrawerFooter: TemplateRef<any>;
  tempProductsDrawerRef: NzDrawerRef<any, any>;
  @Input() disabled: boolean = false;
  @Input() controlName: string = '';

  _field: ModelField;
  totalProducts: number;
  @Input() set field(value: any) {
    this._field = value;
    if (value.Object != null) {
      this.objectType = value.Object;
    }
  }
  get field() {
    return this._field;
  }
  private _formGroup: FormGroup;
  public get formGroup(): FormGroup {
    return this._formGroup;
  }
  @Input()
  public set formGroup(value: FormGroup) {
    this._formGroup = value;
    if (value != null) {
      let control = value.get(this.controlName);
      if (control != null) {
        this.patchValues(control.value);
      } else {
        setTimeout(() => {
          control = value.get(this.controlName);
          this.patchValues(control!.value);
        }, 1000);
      }
    }
  }
  records: any[] = [];
  objectType = -1;
  selectedRecordsArray: any[] = [];
  filterStatement = '';
  selectedRecords = new Set<any>();

  productsPayload: ListPayload = {
    Filters: {},
    IsAscend: false,
    SortBy: 'Id',
    PageIndex: 0,
    PageSize: 10,
    Attributes: [],
  };
  listColumns = productColumns;
  constructor(injector: Injector, private productService: ProductService) {
    super(injector);
  }

  ngOnInit() {}
  getObjectRows(objectType: number, isPatchingValues: boolean) {
    if (objectType !== 12) {
      return this.attributesService
        .getRelationAttributeOptions(objectType, this.filterStatement)
        .pipe(
          tap((response: any) => {
            this.records = response.map((res: any) => {
              return {
                Id: res.id ?? res.Id,
                Name: res.name ?? res.Name,
              };
            });
          })
        );
    } else {
      this.productsPayload.Filters['Id'] = {
        Operator: FilterOperator.isNotEqual,
        Type: FilterType.Number,
        Value: this.route.snapshot.params['id'],
        AdditionalInfo: '',
      };
      return this.productService.getProductsList(this.productsPayload).pipe(
        tap((response) => {
          this.records = response.records;
          this.totalProducts = response.recordsCount;
          this.isLoading = false;
        })
      );
    }
  }
  onItemChecked(obj: any, status: boolean) {
    if (status === true) {
      this.selectedRecords.add(obj);
    } else if (this.selectedRecords.has(obj)) {
      this.selectedRecords.delete(obj);
    }
  }
  deleteRow(obj: any) {
    this.selectedRecordsArray = this.selectedRecordsArray.filter(
      (x) => x.id != obj.id || x.Id != obj.Id
    );
    // const id = obj.id ?? obj.Id;
    this.selectedRecords = new Set(this.selectedRecordsArray);
    this.selectRows();
  }
  selectRows() {
    const control = this.formGroup.get(this.controlName);
    if (control != null) {
      if (this.selectedRecords.size > 0) {
        control.setValue(
          Array.from(this.selectedRecords)
            .map((x) => x.id)
            .join(',')
        );
      } else {
        control.setValue(null);
      }
    }
    this.selectedRecordsArray = [];
    this.selectedRecordsArray = Array.from(this.selectedRecords);
    if (this.tempProductsDrawerRef != null) {
      this.tempProductsDrawerRef.close();
    }
  }
  cancelSelection() {
    this.selectedRecords.clear();
    this.tempProductsDrawerRef.close();
  }
  showRecordsModal() {
    this.subscriptions.push(
      this.getObjectRows(this.objectType, false).subscribe()
    );
    this.tempProductsDrawerRef = this.drawerService.create({
      nzTitle: 'Choose records to add',
      nzContent: this.productsDrawerTemplate,
      nzWidth: '90%',
      nzFooter: this.recordsDrawerFooter,
    });
  }
  patchValues(values: string) {
    this.selectedRecords.clear();
    if (values == null) {
      return;
    }
    this.subscriptions.push(
      this.getObjectRows(this.objectType, false)
        .pipe(
          tap(() => {
            const ids = values.split(',');
            if (this.objectType !== 12) {
              ids.forEach((id) => {
                this.selectedRecords.add(+id);
                this.selectedRecordsArray = [
                  ...this.selectedRecordsArray,
                  this.records.find((x) => x.Id == id || x.id == id),
                ];
              });
            } else {
              this.selectedRecords = new Set([
                ...Array.from(this.selectedRecords),
                ...ids.map((x) => +x),
              ]);
              const joinedIds = Array.from(this.selectedRecords).join(',');
              this.connectionService.get(
                `${AppConfigService.settings.dataApiUrl}Product?filter=Id in (${joinedIds})`,
                (response) => {
                  const value = response.value as any[];
                  ids.forEach((id) => {
                    this.selectedRecordsArray = [
                      ...this.selectedRecordsArray,
                      value
                        .map((x) => {
                          return { id: x.Id, name: x.Name, sku: x.Sku };
                        })
                        .find((x) => x.id == id),
                    ];
                  });
                  this.selectedRecords = new Set(this.selectedRecordsArray);
                }
              );
            }
          })
        )
        .subscribe()
    );
  }

  onProductSelectionChange(selectedRecords: Set<any>) {
    this.selectedRecords = selectedRecords;
    this.selectedRecordsArray = [];
    this.selectedRecordsArray = Array.from(selectedRecords);
  }

  handleFiltersChanges(filter: any) {
    if (filter == null) return;
    // deleting the filter if the value was null or empty
    const additionalInfo = JSON.parse(filter.filter.AdditionalInfo ?? '');
    if (
      (['', null, undefined, 'null'].includes(filter.filter.Value?.trim()) &&
        additionalInfo.needValue == null) ||
      (additionalInfo.needValue != null && additionalInfo.needValue === true)
    ) {
      delete this.productsPayload.Filters[filter.code];
    }
    const keys = Object.keys(this.productsPayload.Filters);

    if (keys.includes(filter.code)) {
      this.productsPayload.Filters[filter.code] = filter.filter;
    } else if (
      !['', null, undefined, 'null'].includes(filter.filter.Value) ||
      additionalInfo.needValue === false
    ) {
      this.productsPayload.Filters = {
        ...this.productsPayload.Filters,
        [filter.code]: filter.filter,
      };
    }
    this.getObjectRows(12, false);
  }
}
